import React, { Suspense } from "react";
import {
    BrowserRouter,
    Navigate,
    Route,
    Routes
} from "react-router-dom";
import withVendorTnCCheck from "src/utils/hocs/TNCCheck/withVendorTnCCheck";
import withBookingRulesAndState from "src/utils/hocs/withBookingRulesAndState";

// Containers
const DefaultLayout = React.lazy(() => import('../layout/DefaultLayout'));

// Pages
const Login = React.lazy(() => import('../views/pages/login/Login'));
const Register = React.lazy(() => import('../views/pages/register/Register'));
const SendOTP = React.lazy(() => import('../views/pages/forgotPassword/SendOTP'));
const ForgotPassword = React.lazy(() => import('../views/pages/forgotPassword/ForgotPassword'));
const Page404 = React.lazy(() => import('../views/pages/page404/Page404'));
const Page500 = React.lazy(() => import('../views/pages/page500/Page500'));
const InvoiceGenerator = React.lazy(() => import('../views/invoiceMaster/InvoiceGenerator'));
const DutySlipGenerator = React.lazy(() => import('../views/bookings/DutySlipGenerator'));
const ProformaInvoiceGenerator = React.lazy(() => import('../views/proformaInvoiceMaster/ProformaInvoiceGenerator'));
const BillCoverReportGenerator = React.lazy(() => import('../views/billCoverReport/BillCoverReportGenerator'));
const CreditNotesHTML = React.lazy(() => import('../views/creditNotes/creditNoteHtml/CreditNotesHTML'));
const DebitNotesHTML = React.lazy(() => import('../views/debitNotes/debitNoteHtml/DebitNotesHTML'));
const VendorInvoiceGenerator = React.lazy(() => import('../views/vendorInvoiceMaster/VendorInvoiceGenerator'));

const loading = (
    <div className="pt-3 text-center">
        <div className="sk-spinner sk-spinner-pulse"></div>
    </div>
)

const AuthRoute = () => {
    return (
        <BrowserRouter>
            <Suspense fallback={loading}>
                <Routes>
                    <Route exact path="/" element={<Login />} />
                    <Route exact path="/register" element={<Register />} />
                    <Route exact path="/forgot-password" element={<SendOTP />} />
                    <Route exact path="/reset-password" element={<ForgotPassword />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </Suspense>
        </BrowserRouter>
    )
};

const AppRoute = () => {
    return (
        <BrowserRouter>
            <Suspense fallback={loading}>
                <Routes>
                    <Route exact path="/404" element={<Page404 />} />
                    <Route exact path="/500" element={<Page500 />} />
                    <Route exact path="/invoices/download/:id" element={<InvoiceGenerator />} />
                    <Route exact path="/duty-slip/download/:id" element={<DutySlipGenerator />} />
                    <Route exact path="/proforma-invoice/download/:id" element={<ProformaInvoiceGenerator />} />
                    <Route exact path="/credit-note/download/:id" element={<CreditNotesHTML />} />
                    <Route exact path="/debit-note/download/:id" element={<DebitNotesHTML />} />
                    <Route exact path="/vendor/invoices/download/:id" element={<VendorInvoiceGenerator />} />
                    <Route exact path="/vendor/invoices/download/:id" element={<VendorInvoiceGenerator />} />
                    <Route exact path="/bill-cover/download/" element={<BillCoverReportGenerator />} />
                    <Route path="*" element={<DefaultLayout />} />
                </Routes>
            </Suspense>
        </BrowserRouter>
    )
};

export {
    AuthRoute
};

export default React.memo(
    withBookingRulesAndState(
        withVendorTnCCheck(AppRoute)
    )
);
